import { Link } from 'react-router-dom';
import { LegalPage } from './LegalPage';
import { LEGAL_CONTACT, LEGAL_VERSIONS } from '@makhe/shared';

export default function PrivacyPage() {
  return (
    <LegalPage title="Privacy Policy" lastUpdated={LEGAL_VERSIONS.privacy}>
      <p>
        This Privacy Policy explains how {LEGAL_CONTACT.companyName} (&quot;Makhe&quot;) processes
        personal information under the Protection of Personal Information Act, 2013 (POPIA). By
        using Makhe you agree to this policy.
      </p>

      <h2>1. Responsible party</h2>
      <p>
        {LEGAL_CONTACT.companyName}
        <br />
        Information Officer: {LEGAL_CONTACT.informationOfficer}
        <br />
        Contact: <a href={`mailto:${LEGAL_CONTACT.email}`}>{LEGAL_CONTACT.email}</a>
      </p>

      <h2>2. What we collect</h2>
      <ul>
        <li>
          <strong>Account:</strong> name, email, phone (required before booking), profile photo,
          gender (optional), bio.
        </li>
        <li>
          <strong>Verification:</strong> institution, hashed student number, student card image
          (stored securely; deleted after verification review per retention schedule).
        </li>
        <li>
          <strong>Location:</strong> campus, residence, approximate service area (geohash/coordinates).
        </li>
        <li>
          <strong>Transactions:</strong> bookings, payments metadata (Paystack processes card
          details — we do not store card numbers).
        </li>
        <li>
          <strong>Content:</strong> service videos/photos, reviews, customisation notes, reference
          images.
        </li>
        <li>
          <strong>Technical:</strong> device tokens (push), cookies/analytics (see{' '}
          <Link to="/legal/cookie-policy">Cookie Policy</Link>).
        </li>
        <li>
          <strong>Legal consent:</strong> version and timestamp of Terms/Privacy/Seller Agreement
          acceptance.
        </li>
      </ul>

      <h2>3. Why we process data</h2>
      <p>
        To operate the marketplace: verify student status, match buyers and sellers, process
        payments, support bookings, prevent fraud, enforce safety rules, comply with law, and
        improve the product.
      </p>

      <h2>4. Sharing phone numbers</h2>
      <p>
        Your phone number is shared with the other party to an <strong>accepted</strong> booking
        only, for coordination. It is not shown publicly on your profile.
      </p>

      <h2>5. Third-party processors</h2>
      <p>
        Firebase/Google (hosting, database, auth, storage), Paystack (payments), Google Maps
        (location), Sentry (errors), PostHog (analytics). Each has its own privacy policy.
        Data may be processed outside South Africa with appropriate safeguards.
      </p>

      <h2>6. Retention</h2>
      <ul>
        <li>Booking and transaction records: 7 years (legal/tax requirements).</li>
        <li>Student card images: deleted within 90 days of verification decision where possible.</li>
        <li>Other profile data: until you delete your account, subject to legal holds.</li>
      </ul>

      <h2>7. Your rights (POPIA)</h2>
      <p>
        You may request access, correction, or deletion of your personal information. Use the
        in-app data export on{' '}
        <Link to="/settings/account">Settings → Account</Link> or email{' '}
        <a href={`mailto:${LEGAL_CONTACT.email}`}>{LEGAL_CONTACT.email}</a>. You may complain to
        the Information Regulator of South Africa.
      </p>

      <h2>8. Security</h2>
      <p>
        We use encryption in transit, Firestore security rules, and server-side validation for
        sensitive operations. No system is 100% secure — report concerns promptly.
      </p>

      <h2>9. Children</h2>
      <p>Makhe is for adult students (18+). We do not knowingly collect data from minors.</p>

      <h2>10. Changes</h2>
      <p>
        We may update this policy. Material changes will be notified in-app; continued use after
        notice constitutes acceptance where permitted by law.
      </p>
    </LegalPage>
  );
}
